import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { semanticColors } = capitalDesignTokens;

export const muiStyles = createTypedSxStyles({
  root: {
    display: 'flex',
    width: '100%',
    padding: '16px 24px 8px 24px',
    backgroundColor: semanticColors.background.primary,
    justifyContent: 'space-between',
    borderBottom: `1px solid ${semanticColors.border.tertiary}`,
    flexDirection: 'column',
  },
  headerContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  breadCrumbsContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  breadcrumbsLink: {
    fontSize: '14px',
    textDecorationLine: 'underline',
    fontStyle: 'normal',
    fontWeight: 400,
    color: semanticColors.foreground.action,
  },
  titleStyle: {
    fontSize: '14px',
    color: semanticColors.foreground.secondary,
    fontStyle: 'normal',
    fontWeight: 400,
  },
  titleContainer: {
    display: 'flex',
    width: '100%',
  },
  titleText: {
    maxWidth: '40%',
  },
  publicationTitle: {
    paddingTop: '16px',
    paddingBottom: '8px',
    paddingRight: '12px',
    display: 'flex',
  },
  storyTitle: {
    color: semanticColors.foreground.primary,
    fontWeight: 700,
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  buttonContainer: {
    display: 'flex',
    padding: '16px 8px 8px 0px',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  settingsButtonContainer: {
    display: 'flex',
    padding: '16px 8px 8px 0px',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  actionContainerOnlyExport: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'right',
  },
  editButton: {
    verticalAlign: 'super',
    marginLeft: '4px',
    '& .MuiButton-startIcon svg': {
      fill: semanticColors.foreground.action,
    },
  },
});
